import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InstagramFeed = ({ posts }) => {
  const handleInstagramClick = () => {
    window.open('https://instagram.com/chapatiplus', '_blank');
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
            Follow Us on Instagram
          </h2>
          <p className="text-muted-foreground text-sm md:text-base">
            @chapatiplus - Daily food inspiration and special offers
          </p>
        </div>
        <Button
          variant="default"
          size="default"
          iconName="Instagram"
          iconPosition="left"
          onClick={handleInstagramClick}
          className="hidden md:flex"
        >
          Follow Us
        </Button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-8">
        {posts?.map((post) => (
          <div
            key={post?.id}
            onClick={handleInstagramClick}
            className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer bg-card shadow-md hover:shadow-xl transition-all duration-300"
          >
            <Image
              src={post?.image}
              alt={post?.imageAlt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 text-white">
                <div className="flex items-center gap-3 md:gap-4 text-xs md:text-sm">
                  <div className="flex items-center gap-1">
                    <Icon name="Heart" size={16} className="fill-current" />
                    <span>{post?.likes}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="MessageCircle" size={16} />
                    <span>{post?.comments}</span>
                  </div>
                </div>
              </div>
            </div>

            {post?.isNew && (
              <div className="absolute top-2 right-2 bg-primary text-primary-foreground px-2 py-1 rounded-full text-xs font-medium">
                New
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="text-center">
        <Button
          variant="outline"
          size="lg"
          iconName="Instagram"
          iconPosition="left"
          onClick={handleInstagramClick}
          fullWidth
          className="md:hidden"
        >
          Follow @chapatiplus on Instagram
        </Button>
        <Button
          variant="outline"
          size="lg"
          iconName="ExternalLink"
          iconPosition="right"
          onClick={handleInstagramClick}
          className="hidden md:inline-flex"
        >
          View Full Instagram Profile
        </Button>
      </div>
    </div>
  );
};

export default InstagramFeed;